import styles from './ConfirmButton.module.scss';

interface ConfirmButtonProps {
  variant?: 'confirm' | 'remove';
  text: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const ConfirmButton = ({
  variant = 'confirm',
  text,
  onClick,
  disabled = false,
}: ConfirmButtonProps) => {
  const buttonClass = variant === 'remove' ? styles.removeButton : styles.confirmButton;

  return (
    <button className={buttonClass} onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );
};
